import { Outlet, Link } from "react-router-dom";
import Header from "../components/Header/Header.js"
import SideKefu from "../components/SideKefu/SideKefu.js"
import Footer from "../components/Footer/Footer.js"
export default function Index() {
  return (
    <>
      <div>
        <Header />
        <Outlet />
        <Footer />
        <SideKefu />
      </div>

    </>
  );
}